import { render, staticRenderFns } from "./UploadArea.vue?vue&type=template&id=3b6ca7c0"
import script from "./UploadArea.vue?vue&type=script&lang=ts"
export * from "./UploadArea.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports